import { PageHero } from '../components/PageHero'
import { useSeo } from '../lib/useSeo'

function Bloc({ titre, children }: { titre: string; children: React.ReactNode }) {
  return (
    <section className="border-b border-navy/10 py-6 last:border-0">
      <h2 className="font-display text-lg font-bold text-navy">{titre}</h2>
      <div className="mt-3 space-y-1.5 text-sm leading-relaxed text-ink/75">{children}</div>
    </section>
  )
}

export function MentionsLegales() {
  useSeo(
    'Mentions légales — Maison Gilles',
    'Mentions légales du site de Maison Gilles, spécialiste en matériel de jardin à Jambes (Namur).',
  )
  return (
    <>
      <PageHero titre="Mentions légales" />
      <section className="bg-white py-12 lg:py-16">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <Bloc titre="1. Éditeur du site">
            <p>Raison sociale : Maison Gilles</p>
            <p>Forme juridique : SA (Société Anonyme)</p>
            <p>Capital social : 148 000 €</p>
            <p>Numéro d'entreprise (BCE) : 0446916810</p>
            <p>Numéro d'identification TVA intracommunautaire : BE0446916810</p>
            <p>Siège social : Chaussée de Marche 182, 5100 Jambes</p>
            <p>Téléphone : 081 30 11 94</p>
            <p>Adresse e-mail : info@maisongilles.be</p>
            <p>Directeur de la publication : Joseph Gilles</p>
          </Bloc>

          <Bloc titre="2. Hébergeur">
            <p>Nom : Hetzner Online GmbH</p>
            <p>Adresse : Industriestr. 25, 91710 Gunzenhausen, Allemagne</p>
            <p>Téléphone : +49 (0)9831 505-0</p>
            <p>Site web : https://www.hetzner.com</p>
          </Bloc>

          <Bloc titre="3. Conception et réalisation">
            <p>Agence : Aubain Gilles Digital</p>
            <p>Téléphone : 0478 428 359</p>
            <p>Adresse e-mail : aubindigital@gmail.com</p>
          </Bloc>

          <Bloc titre="4. Propriété intellectuelle">
            <p>
              L'ensemble des contenus (textes, photographies, illustrations, logos, graphismes,
              vidéos, etc.) appartient aux auteurs respectifs. Toute reproduction, représentation,
              modification, publication ou adaptation de tout ou partie des éléments du site nécessite
              une autorisation écrite préalable.
            </p>
          </Bloc>

          <Bloc titre="5. Données personnelles">
            <p>
              Conformément aux lois applicables, les utilisateurs disposent de droits d'accès, de
              rectification, de suppression et d'opposition concernant leurs données personnelles. Pour
              exercer ces droits : info@maisongilles.be ou par courrier postal.
            </p>
          </Bloc>

          <Bloc titre="6. Cookies">
            <p>
              Le site utilise uniquement les éléments strictement nécessaires à son bon fonctionnement
              (par exemple pour la connexion à l'espace d'administration). Aucun cookie de suivi ou de
              publicité n'est déposé. La carte Google Maps n'est chargée que si vous cliquez pour
              l'afficher ; elle peut alors déposer des cookies relevant de la politique de confidentialité de Google.
            </p>
          </Bloc>

          <Bloc titre="7. Responsabilité">
            <p>
              Maison Gilles ne garantit pas l'exhaustivité ni l'absence d'erreurs concernant les
              informations diffusées sur le site.
            </p>
          </Bloc>

          <Bloc titre="8. Loi applicable et juridiction">
            <p>
              Le présent site est soumis au droit belge. En cas de litige, compétence est attribuée aux
              tribunaux de Namur.
            </p>
          </Bloc>
        </div>
      </section>
    </>
  )
}
